export const siteInfo = {
  name: "AirShip",
  navColor: "#E50046",
  secondary: "#9B4444",
  primary_light_bg: "#E9EFF0",
  asideColor: "#fff",
  payable: 0.6,
  sitekey: "bzadactoklab",
  minimum_price: 1000,
  url: "https://airshipbd.com",
  cdnUrl: "https://cdn.airshipbd.com",
  phone: "01700811396",
  address:
    "Plot # 34, 11, Lift- 4, HM Plaza, Road-02, Uttara, Dhaka-1230, Bangladesh",
  email: "abir.khan41@gmail.com",
  minimum_quantity: 3,
  error: "#C4161C",
  tableHeader: "#E9F0EE",
  by_air: {
    a: 630,
    b: 750,
  },
};

export const getOrderId = (id) => {
  // remove first two characters
  const orderId = id.slice(2);
  // return "BC" + orderId;
  return id;
};
